import { render } from "./ResultsAgendaComponent.vue?vue&type=template&id=c1a3df0c"
import script from "./ResultsAgendaComponent.vue?vue&type=script&lang=js"
export * from "./ResultsAgendaComponent.vue?vue&type=script&lang=js"

import "./ResultsAgendaComponent.vue?vue&type=style&index=0&id=c1a3df0c&lang=scss"
script.render = render

export default script